/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type AllCommentsTabCommentContainer_comment = {
    readonly id: string;
    readonly enteredLive: boolean | null;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly seen: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "ReplyListContainer1_comment" | "IgnoredTombstoneOrHideContainer_comment" | "DeletedTombstoneContainer_comment">;
    readonly " $refType": "AllCommentsTabCommentContainer_comment";
};
export type AllCommentsTabCommentContainer_comment$data = AllCommentsTabCommentContainer_comment;
export type AllCommentsTabCommentContainer_comment$key = {
    readonly " $data"?: AllCommentsTabCommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "refreshStream"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabCommentContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seen",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "refreshStream",
                    "variableName": "refreshStream"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeletedTombstoneContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enteredLive",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastViewerAction",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '578c9c7345a4acd0bd8fcc7fa07dbba8';
export default node;
